import { render, staticRenderFns } from "./CertificationPageEdit.vue?vue&type=template&id=864a5a48&"
import script from "./CertificationPageEdit.vue?vue&type=script&lang=ts&"
export * from "./CertificationPageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('864a5a48')) {
      api.createRecord('864a5a48', component.options)
    } else {
      api.reload('864a5a48', component.options)
    }
    module.hot.accept("./CertificationPageEdit.vue?vue&type=template&id=864a5a48&", function () {
      api.rerender('864a5a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/CertificationPageEdit.vue"
export default component.exports